import React from 'react';
import { WHATSAPP_LINK } from '../constants';

const WhatsAppIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="white" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.611.611l4.458-1.495A11.934 11.934 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.387 0-4.584-.82-6.32-2.192l-.44-.37-3.26 1.093 1.093-3.26-.37-.44A9.935 9.935 0 012 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z" />
  </svg>
);

export const FloatingWhatsAppCTA: React.FC = () => {
  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-slate-950/95 backdrop-blur-sm border-t border-slate-800/50">
        <div className="flex gap-2">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-2 flex-1 py-3 rounded-xl font-bold text-white text-base"
            style={{
              background: 'linear-gradient(135deg, rgb(37, 211, 102), rgb(18, 140, 126))',
              boxShadow: 'rgba(37, 211, 102, 0.3) 0px 0px 20px',
            }}
          >
            <WhatsAppIcon size={20} />
            WhatsApp
          </a>
          <a
            href="#pricing"
            className="flex items-center justify-center gap-1 px-5 py-3 rounded-xl font-bold text-white text-sm"
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            Precios
          </a>
        </div>
      </div>

      <div className="hidden md:block fixed bottom-6 right-6 z-50">
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 px-5 py-3 rounded-full font-bold text-white text-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          style={{
            background: 'linear-gradient(135deg, rgb(37, 211, 102), rgb(18, 140, 126))',
            boxShadow: 'rgba(37, 211, 102, 0.3) 0px 4px 20px',
          }}
        >
          <WhatsAppIcon size={18} />
          Escríbenos
        </a>
      </div>
    </>
  );
};
